module.exports = __webpack_public_path__ + "img/briefs.1a3f4490.png";